"use client"
import { useLanguage } from "../contexts/LanguageContext"
import { MapPin, Phone } from "lucide-react"

const Map = () => {
  const { t } = useLanguage()

  return (
    <section className="map-section">
      <div className="container">
        <h2 className="map-title">{t("mapTitle")}</h2>
        <div className="map-container">
          <iframe
            src="https://www.google.com/maps?q=באר+שבע+14&output=embed"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Gold House Location"
          ></iframe>
          <div className="map-overlay"></div>
          <div className="map-info">
            <h4>{t("locationTitle")}</h4>
            <p>{t("address")}</p>
            <p>
              <a href="tel:+972584204297">
                <Phone size={14} /> 0584204297
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Map